<template>
  <div class="productService">
    <div class="cont">
      <div
        class="serviceItem wow bounceInUp"
        data-wow-duration="3s"
        :data-wow-delay="index * 0.5 + 's'"
        v-for="(item, index) in serviceList"
        :key="item.id"
      >
        <i :class="['s_icon', 'icon_' + item.icon]"></i>
        <div class="s_title">{{ item.title }}</div>
        <ul class="s_detailsList">
          <li v-for="(item1, index) in item.list" :key="index">{{ item1 }}</li>
        </ul>
        <router-link :to="item.url" class="buttonLearnMore">
          了解详情
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "productService",
  data() {
    return {
      serviceList: [
        {
          id: 1,
          key: "zhuanxiangtongji",
          icon: "statistics",
          title: "专项统计与统计数据咨询",
          list: [
            "大型普查",
            "行业/部门专项统计调查",
            "统计培训",
            "基础数据采集与监测",
          ],
          url: "/productService?key=Zhuanxiangtongji",
        },
        {
          id: 2,
          key: "sheqingminyi",
          icon: "investigation",
          title: "社情民意调查研究",
          list: [
            "满意度调查",
            "绩效调查",
            "城乡社会经济状况调查",
            "社情民意调查/社会舆论调查",
          ],
          url: "/productService?key=Sheqingminyi",
        },
        {
          id: 3,
          key: "tongjibaobiao",
          icon: "report",
          title: "统计报表代填代报",
          list: [
            "为广州市房地产企业代填代报",
            "协助报送统计报表",
            "办理《广州市房地产开发企业统计报表年检证》等",
          ],
          url: "/productService?key=Tongjibaobiao",
        },
        {
          id: 4,
          key: "jishuzixun",
          icon: "consult",
          title: "技术咨询",
          list: [
            "统计技术咨询",
            "数据处理电脑编程",
            "调查数据编码录入",
            "代理统计分析",
          ],
          url: "/productService?key=Jishuzixun",
        },
      ],
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
.productService {
  width: 100%;
  height: 442px;
  min-width: 1180px;
  overflow: hidden;
  position: relative;
  margin: -80px 0 0 0;
  .cont {
    display: flex;
    justify-content: space-between;
    width: 1180px;
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 6;
    .serviceItem {
      width: 280px;
      height: 360px;
      padding: 32px 30px 0;
      box-sizing: border-box;
      background-color: #ffffff;
      box-shadow: 3px 4px 9px 1px rgba(22, 22, 22, 0.05);
      -webkit-transition: all 0.2s ease-out;
      transition: all 0.2s ease-out;
      &:hover {
        -webkit-transform: translateY(-3px);
        -ms-transform: translateY(-3px);
        transform: translateY(-3px);
        -webkit-box-shadow: 0 0 10px #999;
        box-shadow: 0 0 10px #999;
      }
      .s_icon {
        display: block;
        width: 60px;
        height: 50px;
        margin: 0 auto;
        &.icon_statistics {
          background: url("../../assets/img/index/icon_statistics.png") center
            no-repeat;
          background-size: 57px 48px;
        }
        &.icon_investigation {
          background: url("../../assets/img/index/icon_investigation.png")
            center no-repeat;
          background-size: 48px 46px;
        }
        &.icon_report {
          background: url("../../assets/img/index/icon_report.png") center
            no-repeat;
          background-size: 40px 46px;
        }
        &.icon_consult {
          background: url("../../assets/img/index/icon_consult.png") center
            no-repeat;
          background-size: 45px 48px;
        }
      }
      .s_title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        padding: 30px 0 0 0;
        text-align: center;
      }
      .s_detailsList {
        padding: 24px 0;
        li {
          font-size: 16px;
          line-height: 30px;
          color: #666666;
          text-align: center;
        }
      }
      .buttonLearnMore {
        display: block;
        width: 106px;
        height: 30px;
        line-height: 30px;
        background-color: $themeColor;
        border-radius: 5px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        margin: 0 auto;
      }
    }
  }
}
</style>
